import React, { useEffect, useState, useRef } from "react";
import { logResponse } from "../utils/logger";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchVerifyEmail } from "../api";

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const token = params.get("token");
  const customerType = params.get("customer_type") || "new";

  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;
    localStorage.removeItem("customer_type");

    if (!token) {
      setMessage("認証トークンが見つかりません。URLをご確認ください。");
      setIsError(true);
      return;
    }

    fetchVerifyEmail(token, customerType)
      .then((data) => {
        logResponse("token:", token);
        logResponse("req:", customerType);
        logResponse("res:", data);
        if (data?.message) {
          localStorage.setItem("customer_type", customerType);

          setMessage(
            <p className="tc bold">
              認証が成功しました。<br />
              <a className="underline" href="/">ログインページ</a>よりログインをお願いします。<br /><br />
              5秒後にログインページへ遷移します
            </p>
          );
          setTimeout(() => {
            navigate("/");
          }, 5000);
        } else {
          setMessage(
            <p className="tc bold">
              メール認証に失敗しました。<br />
              URLが無効または期限切れの可能性があります。<br /><br />
              <a className="underline" href="/">トップページへ戻る</a>
            </p>
          );
          setIsError(true);
        }
      })
      .catch((err) => {
        console.error("認証エラー:", err);
        setMessage("通信エラーが発生しました。時間を置いて再度お試しください。");
        setIsError(true);
      });
  }, [token, customerType, navigate]);

  return (
    <section className="section form-section section-block">
      <div className="form-group">
        <p style={{ color: isError ? "red" : "green", fontWeight: "bold" }}>
          {message || "メール認証中です。しばらくお待ちください…"}
        </p>
      </div>
    </section>
  );
};

export default VerifyEmail;
